(function () {
  if (window.__fcloCollectionColorSwatchInit) return;
  window.__fcloCollectionColorSwatchInit = true;

  function updateCollectionGridCard(card, swatch) {
    var productUrl = swatch.getAttribute('data-product-url');
    var productTitle = swatch.getAttribute('data-product-title');
    var primarySrc = swatch.getAttribute('data-primary-src');
    var primarySrcset = swatch.getAttribute('data-primary-srcset');
    var primaryAlt = swatch.getAttribute('data-primary-alt');
    var salePrice = swatch.getAttribute('data-price');
    var comparePrice = swatch.getAttribute('data-compare-price');
    var priceVaries = swatch.getAttribute('data-price-varies') === 'true';
    var badgeText = swatch.getAttribute('data-product-badge');
    var soldOut = swatch.getAttribute('data-sold-out') === 'true';

    var mediaContainer = card.querySelector('.product-grid-item__container');
    if (mediaContainer) mediaContainer.classList.add('is-loading');

    card.querySelectorAll('[data-grid-link]').forEach(function (link) {
      if (productUrl) link.setAttribute('href', productUrl);
    });

    card.setAttribute('aria-label', productTitle || '');

    var title = card.querySelector('.product__grid__title');
    if (title && productTitle) title.textContent = productTitle;

    var priceWrap = card.querySelector('.product__grid__price');
    if (priceWrap && salePrice) {
      var priceEl = priceWrap.querySelector('.price');
      var compareEl = priceWrap.querySelector('.compare-at');
      var fromPrefix = priceVaries ? 'From ' : '';

      if (priceEl) {
        priceEl.textContent = fromPrefix + salePrice;
        priceEl.classList.toggle('on-sale', !!comparePrice);
      }

      if (comparePrice) {
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'compare-at';
          priceWrap.appendChild(compareEl);
        }
        compareEl.textContent = comparePrice;
      } else if (compareEl) {
        compareEl.remove();
      }
    }

    var soldEl = card.querySelector('.product__grid__price__sold');
    if (soldEl) {
      soldEl.hidden = !soldOut;
    }

    var qvHandle = swatch.getAttribute('data-product-handle');
    var qvTrigger = card.querySelector('[data-fclo-qv-trigger]');
    if (qvTrigger && qvHandle) {
      qvTrigger.setAttribute('data-product-handle', qvHandle);
      if (productTitle) {
        qvTrigger.setAttribute('aria-label', 'Quick view — ' + productTitle);
      }
      var qvWrap = qvTrigger.closest('.fclo-qv-wrap');
      if (qvWrap) qvWrap.hidden = soldOut;
    }
    
    var variant = card.querySelector('product-grid-item-variant:not([hidden])');
    if (variant) {
      variant.classList.toggle('sold-out', soldOut);
      variant.classList.toggle('on-sale', !!comparePrice);
    }

    var badge = card.querySelector('.product__badge');
    if (badge) {
      if (badgeText) {
        badge.textContent = badgeText;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    function finishLoading() {
      if (mediaContainer) mediaContainer.classList.remove('is-loading');
    }

    var primaryImg =
      card.querySelector('[data-grid-current-image] img') ||
      card.querySelector('.product-grid-item__image-wrapper.is-active img');

    if (primaryImg && primarySrc) {
      var onPrimaryImageReady = function () {
        primaryImg.removeEventListener('load', onPrimaryImageReady);
        primaryImg.removeEventListener('error', onPrimaryImageReady);
        finishLoading();
      };

      primaryImg.addEventListener('load', onPrimaryImageReady);
      primaryImg.addEventListener('error', onPrimaryImageReady);
      primaryImg.src = primarySrc;
      if (primarySrcset) primaryImg.setAttribute('srcset', primarySrcset);
      else primaryImg.removeAttribute('srcset');
      primaryImg.alt = primaryAlt || productTitle || '';

      if (primaryImg.complete) onPrimaryImageReady();
    } else {
      finishLoading();
    }

    card.querySelectorAll('[data-fclo-color-swatch]').forEach(function (btn) {
      var isActive = btn === swatch;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      var inner = btn.querySelector('.swatch_color_product_div');
      if (inner) inner.classList.toggle('product_color_border', isActive);
    });
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-fclo-color-swatch]');
    if (!swatch) return;

    var card = swatch.closest('product-grid-item');
    if (!card) return;

    event.preventDefault();
    updateCollectionGridCard(card, swatch);
  });
})();
